"use client";

import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  icon?: React.ReactElement;
  variant?: "primary" | "secondary";
  shine?: boolean;
}

export const Button = ({ children, icon, variant = "primary", shine, ...props }: ButtonProps) => {
  const baseClasses =
    "relative inline-flex items-center justify-center overflow-hidden text-xs md:text-sm font-bold tracking-wide transition-all duration-300 rounded-lg group";

  const variantClasses = {
    primary:
      "px-5 py-1.5 md:px-6 md:py-2 text-white uppercase bg-gradient-to-r from-brand-600 to-brand-500 shadow-md hover:shadow-glow",
    secondary:
      "px-3 py-1.5 text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700 rounded-full",
  };

  const iconClasses = "w-4 h-4 md:w-5 md:h-5 mr-2 transition-transform duration-300";

  return (
    <button
      {...props}
      type="button"
      className={`${baseClasses} ${variantClasses[variant]} ${props.className}`}
    >
      {shine && (
        <span className="absolute inset-0 -translate-x-full animate-shine bg-gradient-to-r from-transparent via-white/50 to-transparent" />
      )}
      {variant === "primary" && (
        <span className="absolute inset-0 w-full h-full bg-gradient-to-b from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      )}
      {icon &&
        React.cloneElement(icon, {
          className: `${iconClasses} ${variant === "primary" ? "group-hover:rotate-90" : ""}`,
        })}
      <span className="relative z-10 whitespace-nowrap">{children}</span>
    </button>
  );
};
